// extracted by mini-css-extract-plugin
export var container = "_dk-0";
export var popoverContent = "_dk-1";
export var tosLink = "_dk-2";